import { Button, Input, notification, Row, Spin, Form } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from '@ant-design/icons';

import config from "../../config.json"
import axios from "axios";
import Success from "../../components/Success"

const LegalDocuments = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [submitted, setSubmit] = useState(false);


  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  }

  const onFinish = async (values: any) => {
    console.log('Form Values:', values);
    var data = {
      email : values.email
    }
    setLoading(true);
    const csrfToken = localStorage.getItem("csrfToken");

    const URL = (config.env === "prod" ? config.prodURL : config.env === "test" ? config.testURL : config.localURL) + "requestlegaldocument";
    console.log("URL: ", URL)
    console.log("Data: ", data)
    try {
      const response = await axios.post(URL, data);
      setSuccess(true);
      setSubmit(true);
      console.log("Form submitted successfully:: ", response.data);
    } catch (error) {
      notification["error"]({
        message: "Submit Error",
        description: "Something went wrong. Please try again later.",
        placement: 'topRight', // Options: 'topLeft', 'topRight', 'bottomLeft', 'bottomRight'
      });
      console.error('Error uploading file:', error);
    }
    setLoading(false)

  };

  return (
    <div className="about-container">
      <div className="content">
        <p style={{ display: 'flex' }}>
          <ArrowLeftOutlined onClick={goBack}></ArrowLeftOutlined>Go back
        </p>
        <h1>Legal Documents</h1>
        {!submitted ? (
          <div>
            <h2>Request Legal Document</h2>
            <Form onFinish={onFinish}>

              <Row justify={"center"}>
                <Form.Item name="email"> 
                  <Input width={300}  />
                </Form.Item>
                <Form.Item style={{ marginLeft: '10px' }}>
                  <Button disabled={loading} type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
                {loading && (
                  <div className="loading-overlay">
                    <Spin size="large" /> {/* Ant Design spinner */}
                  </div>
                )}
              </Row>
            </Form>

          </div>
        ) : (
          <Row justify={"center"}>
            <Success />
          </Row>

        )}

      </div>
    </div>
  )
}


export default LegalDocuments;